export const langMap = {
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  nl: 'nl-NL',
  'pt-BR': 'pt-BR',
  sv: 'sv-SE',
  'zh-Hans': 'zh-CN',
  'zh-Hant': 'zh-TW',
};
